<template>
    <span>
        <form-switch :value="value" @change="handleValueChange" />
        <de-activation-modal
            :property-id="property.id"
            :modal-id="deActivationModalId"
            action="disable"
            @shown="handleModalShown"
            @ok="handleOk"
        />
    </span>
</template>

<script>
    import FormSwitch from '../../generic/form-switch/form-switch.vue';
    import DeActivationModal from '../../common/de-activation-modal.vue';

    export default {
        components: {
            FormSwitch,
            DeActivationModal,
        },
        data() {
            return {
                value: false,
                property: null,
                deActivationModalId: '',
            };
        },
        created() {
            this.value = this.params.value;
            this.property = this.params.data;
            this.deActivationModalId = `modal-de-activation-${this.property.id}`;
        },
        methods: {
            handleModalShown() {
                this.params.api.clearFocusedCell();
            },
            handleValueChange() {
                if (!this.value) {
                    if (this.params.onChange) {
                        this.params.onChange(this.params, { newValue: true });
                    }
                } else {
                    this.$bvModal.show(this.deActivationModalId);
                }
            },
            handleOk({ reason, reasonDetails }) {
                if (this.params.onChange) {
                    this.params.onChange(this.params, {
                        newValue: false,
                        disabledReason: reason,
                        disabledReasonDetails: reasonDetails,
                    });
                }
            },
        },
    };
</script>
